<template>
  <div class="container">
    <div class="header">
      <div class="title">学生课表</div>
    </div>
    <div class="c-body">
      <div class="cell-box" @click="showPopupClick(1)">
        <div class="cell-left">校区</div>
        <div class="cell-right">
          <p class="tips" v-if="schooleVal === ''">{{ '请选择校区' }}</p>
          <p v-else>{{ schooleVal.text }}</p>
          <van-icon name="arrow" color="#ddd" size="18" />
        </div>
      </div>
      <div class="cell-box" @click="showPopupClick(2)">
        <div class="cell-left">学年学期</div>
        <div class="cell-right">
          <p class="tips" v-if="yearVal === ''">{{ '请选择学年学期' }}</p>
          <p v-else>{{ yearVal.text }}</p>
          <van-icon name="arrow" color="#ddd" size="18" />
        </div>
      </div>
      <div class="cell-box" @click="showPopupClick(3)">
        <div class="cell-left">学段</div>
        <div class="cell-right">
          <p class="tips" v-if="classVal === ''">{{ '请选择学段' }}</p>
          <p v-else>{{ classVal.text }}</p>
          <van-icon name="arrow" color="#ddd" size="18" />
        </div>
      </div>
      <div class="query-btn" @click="queryClick">查询</div>
    </div>

    <!-- 弹出层 -->
    <van-popup v-model="showPopup" position="bottom" round :style="{ height: '31%' }">
      <van-picker
        :default-index="defaultIndex"
        :show-toolbar="true"
        :columns="columns"
        @confirm="popupOk"
        @cancel="closeDU"
      />
    </van-popup>
  </div>
</template>
<script>
export default {
  name: '',
  data() {
    return {
      defaultIndex: 0,
      schooleVal: '',
      schooleColums: [],
      yearVal: {
        text: '',
        value: ''
      },
      yearColums: [],
      classVal: '',
      classColums: [],
      showPopup: false,
      curPopup: -1, //1 校区 2 年级 3 班级
      columns: [],
      studentList: []
    }
  },
  created() {
    this.getSchoole()
    this.getSessionNodeList()
  },
  mounted() {},
  methods: {
    showPopupClick(val) {
      if (val === 1) {
        this.columns = this.schooleColums
        console.log(this.schooleColums)
        this.curPopup = 1
      } else if (val === 2) {
        this.columns = this.yearColums
        this.curPopup = 2
      } else if (val === 3) {
        if (this.schooleVal === '') {
          this.$toast.fail('请先选择校区')
          return false
        } else {
          this.columns = this.classColums
          this.curPopup = 3
        }
      }
      this.showPopup = true
    },
    closeDU() {
      this.showPopup = false
    },
    popupOk(selectedValues, selectedOptions, selectedIndexes) {
      if (this.curPopup === 1) {
        this.schooleVal = selectedValues
        this.getStudentGradeBySchool()
        // 学段选择置空
        this.classVal = ''
      } else if (this.curPopup === 2) {
        let idArr = [
          this.yearColums[selectedOptions[0]].value,
          this.yearColums[selectedOptions[0]].children.length > 0
            ? this.yearColums[selectedOptions[0]].children[selectedOptions[1]].value
            : 0
        ]
        let text = selectedValues[0]
        if (selectedValues[1] !== undefined) {
          text = text + selectedValues[1]
        }
        this.yearVal = {
          text: text,
          value: idArr.join(',')
        }
      } else if (this.curPopup === 3) {
        this.classVal = selectedValues
        // 有学段再获取班级
        this.getClassList()
      }
      this.showPopup = false
    },
    queryClick() {
      if (this.schooleVal === '') {
        this.$toast.fail('请先选择校区')
        return false
      }
      if (this.yearVal === '') {
        this.$toast.fail('请先选择学年学期')
        return false
      }
      if (this.classVal === '') {
        this.$toast.fail('请先选择学段')
        return false
      }
      if (this.studentList.length === 0) {
        this.$toast.fail('该班级下没有数据')
        return false
      }
      this.$store.commit('csmstimetable/setCurrentStudent', this.studentList[0].Member[0])
      this.$store.commit('csmstimetable/setStudentVal', {
        schooleVal: this.schooleVal,
        yearVal: this.yearVal,
        classVal: this.classVal
      })
      this.$router.push({
        path: 'studentSchedule'
      })
    },
    //获取校区
    async getSchoole() {
      this.xy.loading()
      let res = await this.xyapi.post(
        this.$store.state.apiPath +
          '/api/ReportPermissionTimeTable/GetMobilePermissionTimeTableStudentOrgIncludeList',
        {
          ApplicationID: this.$store.state.common.menuIDs[1]
        }
      )
      this.xy.unloading()
      if (res.success) {
        this.schooleColums = []
        let resData = res.data
        resData.map(item => {
          this.schooleColums.push({
            text: item.SchoolDistrictName,
            value: item.SchoolDistrictID
          })
        })

        this.schooleVal = this.schooleColums.length > 0 ? this.schooleColums[0] : ''
        if (this.schooleVal !== '') {
          this.getStudentGradeBySchool()
        }
      } else {
        this.$toast.fail(res.data)
      }
    },
    // 获取班级
    async getClassList() {
      this.xy.loading()
      let res = await this.xyapi.post(
        this.$store.state.apiPath +
          '/api/ReportPermissionTimeTable/GetMobilePermissionTimeTableStudentOrgList',
        {
          ApplicationID: this.$store.state.common.menuIDs[1],
          StudentGradeID: this.classVal.value,
          SchoolDistrictID: this.schooleVal.value
        }
      )
      this.xy.unloading()
      if (res.success) {
        this.studentList = res.data
      } else {
        this.$toast.fail(res.data)
      }
    },
    //获取学年学期
    async getSessionNodeList() {
      this.xy.loading()
      let res = await this.xyapi.get(this.xyMApi + '/xy/comm/GetSessionNodeList')
      this.xy.unloading()
      if (res.success) {
        let resData = res.data
        resData.map(item => {
          let children = []
          item.children.map(item1 => {
            children.push({
              text: item1.label,
              value: item1.value
            })
          })
          this.yearColums.push({
            text: item.label,
            value: item.value,
            children: children
          })
        })
        // 默认选中当前学期
        let yearSession = [] //当前学期id
        let yearSessionName = [] //当前学期name
        let index = res.data
          .map(item => {
            return item.IsCurrent
          })
          .indexOf(true)
        if (index !== -1) {
          this.defaultIndex = index
          yearSession.push(res.data[index].value)
          yearSessionName.push(res.data[index].label)
          let index1 = res.data[index].children
            .map(item => {
              return item.IsCurrent
            })
            .indexOf(true)
          if (index1 !== -1) {
            yearSession.push(res.data[index].children[index1].value)
            yearSessionName.push(res.data[index].children[index1].label)
          }
        } else {
          if (res.data.length > 0) {
            yearSession.push(res.data[0].value)
            yearSessionName.push(res.data[0].label)
            if (res.data[0].children.length > 0) {
              yearSession.push(res.data[0].children[0].value)
              yearSessionName.push(res.data[0].children[0].label)
            } else {
              yearSession.push(0)
            }
          }
        }
        if (yearSession[1] !== undefined) {
          this.AcademicSessionID = yearSession[1]
          this.getSchoole('first')
        }
        this.yearVal.text = yearSessionName.join('')
        this.yearVal.value = yearSession.join(',')
      } else {
        this.$toast.fail(res.data)
      }
    },
    //获取学段
    async getStudentGradeBySchool() {
      this.xy.loading()
      let res = await this.xyapi.get(this.xyMApi + '/xy/comm/GetStudentGradeBySchool', {
        schoolDististrictID: this.schooleVal.value
      })
      this.xy.unloading()
      if (res.success) {
        let resData = res.data
        this.classColums = []
        resData.map(item => {
          this.classColums.push({
            text: item.StudentGradeName,
            value: item.StudentGradeID,
            StudentGradeForStudentYearID: item.StudentGradeForStudentYearID
          })
        })
      } else {
        this.$toast.fail(res.data)
      }
    }
  }
}
</script>
<style lang="less" scoped>
.container {
  position: relative;
  background: #fff;
  height: calc(100vh - 90px);
  .title {
    font-size: 50px;
    font-weight: 600;
    color: #191b28;
    padding: 105px 0 0 88px;
  }
  .cell-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 112px;
    padding: 0 32px;
    .cell-left {
      color: #333333;
      font-size: 32px;
      width: 150px;
    }
    .cell-right {
      display: flex;
      align-items: center;
      justify-content: end;
      color: #333333;
      font-size: 32px;
      width: calc(100% - 150px);
      > p {
        margin-right: 16px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      p.tips {
        color: #999;
      }
    }
  }
  .query-btn {
    height: 88px;
    line-height: 88px;
    text-align: center;
    background: #618dfa;
    border-radius: 64px;
    color: #fff;
    margin: 100px auto;
    width: calc(100% - 66px);
  }
  /deep/ .van-picker__toolbar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 32px;
    height: 96px;
  }
  /deep/ .van-picker__cancel {
    color: #5a6073;
    font-size: 32px;
  }
  /deep/ .van-picker__confirm {
    color: #2954ff;
    font-size: 32px;
  }
}
.header {
  height: 335px;
  background-image: url('../../../../assets/csmsTimeTable/class-1.png');
  background-size: 100%;
}
.c-body {
  position: relative;
  top: -80px;
  background: #fff;
  border-radius: 40px 40px 0px 0px;
  padding-top: 32px;
}
</style>
